export const FeatureFlags = {
  campus_flow: {
    flagKey: "ENG-4047_campus_flow",
    defaultValue: false,
  },
  map_view_by_school: {
    flagKey: "ENG-1398_map_view_by_school",
    defaultValue: false,
  },
}
